import { render, staticRenderFns } from "./RescueOfOtherService.vue?vue&type=template&id=292a385e&scoped=true&"
import script from "./RescueOfOtherService.vue?vue&type=script&lang=js&"
export * from "./RescueOfOtherService.vue?vue&type=script&lang=js&"
import style0 from "./RescueOfOtherService.vue?vue&type=style&index=0&id=292a385e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292a385e",
  null
  
)

export default component.exports